import {
  FETCH_DEPARTMENTS,
  FETCH_DEPARTMENTS_SUCCESS,
  FETCH_DEPARTMENTS_FAIL
} from '../../actions/cm/departments';

export const initialState = {
  list: [],
  isLoading: false,
  hasError: false,
  hasLoaded: false
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_DEPARTMENTS:
      return {
        ...state,
        isLoading: true,
        hasError: false
      };
    case FETCH_DEPARTMENTS_SUCCESS:
      return {
        ...state,
        hasLoaded: true,
        list: payload || [],
        isLoading: false
      };
    case FETCH_DEPARTMENTS_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true
      };
    default:
      return state;
  }
}
